import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { api, fileUrl } from "@/lib/api";
import { LogoMark } from "@/components/LogoMark";
import { StoreFooter } from "@/components/StoreFooter";

function StorefrontHeader() {
  return (
    <>
      <div className="gov-strip">
        <span className="tri"><span className="b saffron" /><span className="b white" /><span className="b green" /></span>
        <Link to="/about">About us</Link>
        <Link to="/authorised-users">Authorised users</Link>
        <Link to="/contact">Contact</Link>
      </div>
      <header className="store-header">
        <Link to="/" className="store-brand"><LogoMark small /><span>GI Bharat<small>By True Vision Welfare Society</small></span></Link>
        <nav>
          <Link to="/login" className="store-login">Sign in</Link>
        </nav>
      </header>
    </>
  );
}

export default function AboutUs() {
  const [about, setAbout] = useState(null);
  const [counters, setCounters] = useState({ authorised_users_total: 500, crafts: [] });

  useEffect(() => {
    api.get("/about").then(r => setAbout(r.data)).catch(() => setAbout({}));
    api.get("/counters").then(r => setCounters(r.data)).catch(() => {});
  }, []);

  if (!about) return <main className="storefront"><StorefrontHeader /><div className="pd-shell" data-testid="about-loading">Loading…</div></main>;

  return (
    <main className="storefront" data-testid="about-page">
      <StorefrontHeader />

      <section className="section" style={{ paddingTop: 40 }}>
        <p className="eyebrow">ABOUT TRUE VISION WELFARE SOCIETY</p>
        <h1 style={{ color: "var(--tv-green)", fontSize: "clamp(30px, 4vw, 44px)" }}>Rooted in origin. Working for the makers of India.</h1>
        <p className="subtitle" style={{ maxWidth: 780, fontSize: 15, textAlign: "justify" }}>
          {about.intro || `True Vision Welfare Society is a not-for-profit society established in ${about.established_year || 2017}. Since ${about.gi_since_year || 2023} we have focused on Geographical Indication (GI) services — supporting authorised-user registrations, digital profiles, product visibility, and consumer trust for India's craft communities.`}
        </p>
      </section>

      {about.hero_photo && (
        <section className="section" style={{ paddingTop: 0 }}>
          <img src={fileUrl(about.hero_photo)} alt="True Vision at work" style={{ width: "100%", maxHeight: 460, objectFit: "cover", borderRadius: 8 }} data-testid="about-hero-photo" />
        </section>
      )}

      <section className="stats-band" data-testid="about-stats">
        <div className="inner">
          <div><div className="n" data-testid="stat-total">{counters.authorised_users_total}+</div><div className="lbl">Authorised users</div></div>
          {(counters.crafts || []).map((c, i) => (
            <div key={i} data-testid={`stat-craft-${i}`}>
              <div className="n">{c.count}+</div>
              <div className="lbl">{c.name}</div>
              <div className="desc">{c.description}</div>
            </div>
          ))}
          <div><div className="n">{about.gi_since_year || 2023}</div><div className="lbl">Working for GI since</div></div>
        </div>
      </section>

      <section className="section" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 30 }}>
        {about.mission && <div><h2 style={{ color: "var(--tv-green)" }}>Our mission</h2><p className="muted" style={{ textAlign: "justify" }}>{about.mission}</p></div>}
        {about.vision && <div><h2 style={{ color: "var(--tv-green)" }}>Our vision</h2><p className="muted" style={{ textAlign: "justify" }}>{about.vision}</p></div>}
      </section>

      {about.work_details?.length > 0 && (
        <section className="section" style={{ paddingTop: 20 }}>
          <h2 style={{ color: "var(--tv-green)" }}>Our work</h2>
          <div className="store-grid" style={{ marginTop: 18 }}>
            {about.work_details.map((w, i) => (
              <div className="admin-tile" key={i} data-testid={`work-${i}`}>
                {w.photo && <img src={fileUrl(w.photo)} alt="" style={{ width: "100%", height: 160, objectFit: "cover", borderRadius: 6, marginBottom: 10 }} />}
                <h4>{w.title}</h4>
                <p style={{ color: "var(--muted)", fontSize: 13 }}>{w.description}</p>
              </div>
            ))}
          </div>
        </section>
      )}

      {about.achievements?.length > 0 && (
        <section className="section" style={{ paddingTop: 10 }}>
          <h2 style={{ color: "var(--tv-green)" }}>Achievements</h2>
          <div className="store-grid" style={{ marginTop: 18 }}>
            {about.achievements.map((a, i) => (
              <div className="admin-tile" key={i} data-testid={`ach-${i}`}>
                {a.photo && <img src={fileUrl(a.photo)} alt="" style={{ width: "100%", height: 160, objectFit: "cover", borderRadius: 6, marginBottom: 10 }} />}
                <h4>{a.title}</h4>
                {a.date && <p className="eyebrow" style={{ margin: 0 }}>{a.date}</p>}
                <p style={{ color: "var(--muted)", fontSize: 13 }}>{a.description}</p>
              </div>
            ))}
          </div>
        </section>
      )}

      <StoreFooter />
    </main>
  );
}
